export class HelpModel { 
    uid: string;
    cultureId: string;
    section: string;
    description: string;
    parent: string;
    keyword: string;

    constructor() { }
}
